export const OPEN_SOURCE = '/open-source'
export const PRIVACY_POLICY = '/privacy-policy'
